export default "__VITE_PUBLIC_ASSET__7cf44e65__"